import { TextInput } from "flowbite-react";

export default function Input({ ...props }: typeof TextInput.defaultProps) {
  return <TextInput className="w-[340px] max-[480px]:w-full" {...props} />;
}
